var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.106,
    height: 16.261,
    viewBox: "0 0 18.106 16.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera-svgrepo-com",
    transform: "translate(-2.25 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M11.768,15.535A2.768,2.768,0,1,0,9,12.768,2.768,2.768,0,0,0,11.768,15.535Z",
    transform: "translate(-0.465 -0.465)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M3,15.809V8.8a4.584,4.584,0,0,1,.2-1.945,1.845,1.845,0,0,1,.806-.806,4.584,4.584,0,0,1,1.945-.2h.973a2.071,2.071,0,0,0,.222-.006.923.923,0,0,0,.668-.413,2.072,2.072,0,0,0,.1-.2,4.143,4.143,0,0,1,.21-.393,1.845,1.845,0,0,1,1.336-.826A4.143,4.143,0,0,1,9.911,4H12.7a4.143,4.143,0,0,1,.445.012,1.845,1.845,0,0,1,1.336.826,4.165,4.165,0,0,1,.21.393,2.051,2.051,0,0,0,.1.2.923.923,0,0,0,.668.413,2.073,2.073,0,0,0,.223.006h.973a4.584,4.584,0,0,1,1.945.2,1.845,1.845,0,0,1,.806.806,4.584,4.584,0,0,1,.2,1.945v7.011a4.584,4.584,0,0,1-.2,1.945,1.845,1.845,0,0,1-.806.806,4.584,4.584,0,0,1-1.945.2H5.952a4.584,4.584,0,0,1-1.945-.2,1.845,1.845,0,0,1-.806-.806A4.584,4.584,0,0,1,3,15.809Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraActiveIcon);
export default __webpack_public_path__ + "static/media/camera-active-icon.b31bb01947aa56d3b7079ea2ab7ae74f.svg";
export { ForwardRef as ReactComponent };